import { createContext } from "react";

// `true` внутри шторки на телефоне: там меню всегда развёрнуто, подсказки к значкам не нужны,
// а вместо «Свернуть меню» — «Закрыть меню».
export const SidebarDrawerContext = createContext(false);
